import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {appHeaderPromo_template} from "../components/templates/appHeaderPromo_template";
import {vnApp_sentinelbi} from "../components/vnApp_sentinelbi";

declare var page: any;
declare var ko: any;

export class headerPromo extends vnModule_knockoutJS{

    protected getModuleName(){
        return "headerPromo";
    }

    public appHeader: appHeaderPromo_template;
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent() : Array<Element>{

        let vnApp : vnApp_sentinelbi = <vnApp_sentinelbi>this.getVnAppZone().app;

        this.appHeader = new appHeaderPromo_template("mainHeaderPromo", this.viewModel, this);

        return [this.appHeader.build()]
    }

    public fillPage() : void{

    }
}



// WEBPACK FOOTER //
// ./js/modules/headerPromo.ts